<div class="flex-fill d-flex flex-column card p-3">
  @if (true) {
    <div>
      <dx-form [formData]="filter" [colCount]="3" (onEditorEnterKey)="getData()" appAutofocusForm="companyName">
        <!-- <dxi-item itemType="group" caption="Load Ticket Files" style="border: solid"> -->
        <dxi-item>
          <div *dxTemplate style="border-width: 1px; border-color: black; border-style: dashed">
            <dx-file-uploader
              name="fileUpload"
              selectButtonText="Select File(s)"
              class="attachments"
              accept="*"
              uploadMode="instantly"
              [showFileList]="false"
              [multiple]="true"
              [uploadUrl]="uploadUrl"
              [uploadHeaders]="uploadHeader"
              (onUploadStarted)="uploadStarted($event)"
              (onUploadError)="uploadError($event)"
              (onUploaded)="uploaded($event)"
              >
            </dx-file-uploader>
          </div>
        </dxi-item>
        <dxi-item>
          @if (attachments) {
            <ul style="list-style-type: none; padding-inline-start: 0px">
              @for (attachment of attachments; track attachment) {
                <li>
                  <a title="remove" (click)="removeAttachment(attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                  <a title="view" (click)="openAttachment(attachment)">{{ attachment.created | date : "short" }} - {{ attachment.name }}</a>
                </li>
              }
            </ul>
          }
        </dxi-item>
      <!-- </dxi-item> -->
      <!-- <dxi-item itemType="group" [colSpan]="2" [colCount]="4">
      <dxi-item dataField="companyName"></dxi-item>
      <dxi-item dataField="firstName"></dxi-item>
      <dxi-item dataField="lastName"></dxi-item>
      <dxi-item dataField="billCity" [label]="{ text: 'City' }"></dxi-item>
    </dxi-item>
    <dxi-item [colSpan]="3">
      <div *dxTemplate class="btn-toolbar justify-content-end align-items-center">
        <div *ngIf="loads" class="me-3">{{ loads.length }} {{ loads.length === 1 ? "item found" : "items found" }}</div>
        <button type="button" accesskey="s" (click)="getData()" class="btn btn-primary me-1">Search</button>
        <button type="button" (click)="clear()" class="btn btn-light">Clear</button>
      </div>
    </dxi-item> -->
  </dx-form>
</div>
}

<div class="d-flex">
  <div class="column ms-2 me-3"><span class="color-legend red-cell"></span> - Value Missing</div>
  <div class="column ms-2 me-3"><span class="color-legend price-not-verified"></span> - Price Not Verified</div>
  <div class="column ms-2 me-3"><span class="color-legend price-from-quote"></span> - Price From Quote</div>
  <div class="column ms-2 me-3"><span class="color-legend manual-delivery"></span> - Manual Ticket With Delivery Fee</div>
</div>

<div class="d-flex flex-fill flex-column">
  <dx-data-grid
    #dataGrid
    keyExpr="id"
    class="flex-fill d-flex flex-column"
    [dataSource]="loads"
    (onRowUpdated)="onRowUpdated($event)"
    (onRowPrepared)="onRowPrepared($event)"
    (onRowDblClick)="rowDoubleClick($event)"
    (onCellDblClick)="cellDoubleClick($event)"
    (onCellPrepared)="onCellPrepared($event)"
    [customizeColumns]="customizeColumns"
    >
    <dxi-column dataField="id" width="65"></dxi-column>
    <dxi-column dataField="ticketAttachmentTypeName" caption="Type" width="100"></dxi-column>
    <dxi-column dataField="loadDate" width="100"></dxi-column>
    <dxi-column dataField="ticketNumber" width="100"></dxi-column>
    <dxi-column dataField="customerString" caption="Customer Code" width="100"></dxi-column>
    <dxi-column dataField="customer.companyName" caption="Company Name" width="175" cellTemplate="linkTemplate"></dxi-column>
    <dxi-column dataField="description1" width="125" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
    <dxi-column dataField="description2" width="125" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
    <dxi-column dataField="productId" width="100"></dxi-column>
    <dxi-column dataField="productString" width="125"></dxi-column>
    <!-- <dxi-column dataField="unitPrice" width="115" [format]="{ type: 'currency', precision: 2 }"></dxi-column> -->
    <dxi-column dataField="price" width="115" [format]="{ type: 'currency', precision: 2 }" [editorOptions]="{ step: 0 }"></dxi-column>
    <dxi-column dataField="priceVerified" width="125"></dxi-column>
    <dxi-column dataField="loadAdditivesHtml" caption="Additives" width="275" [encodeHtml]="false"></dxi-column>
    <dxi-column dataField="weightQuantity" width="125"></dxi-column>
    <dxi-column dataField="yardQuantity" width="125"></dxi-column>
    <dxi-column dataField="uniqueId" width="100"></dxi-column>
    <dxi-column dataField="mixString" width="115"></dxi-column>
    <dxi-column dataField="carrier" width="175"></dxi-column>
    <dxi-column dataField="vehicle" width="175"></dxi-column>
    <dxi-column dataField="order" width="125"></dxi-column>
    <dxi-column dataField="poNumber" width="125"></dxi-column>
    <dxi-column dataField="tareWeight" width="175"></dxi-column>
    <dxi-column dataField="grossWeight" width="175"></dxi-column>
    <dxi-column dataField="netWeight" width="175"></dxi-column>
    <dxi-column dataField="unitOfMeasure" width="175"></dxi-column>
    <dxi-column></dxi-column>

    <div *dxTemplate="let cell of 'linkTemplate'">
      @if (cell.data) {
        <a [routerLink]="[]" (click)="openCustomer(cell.data.customerId)">{{ cell.text }}</a>
      }
    </div>

    <dxo-sorting [mode]="'multiple'"></dxo-sorting>
    <dxo-selection mode="multiple"></dxo-selection>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="load-search-grid"></dxo-state-storing>
    <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
    <div *dxTemplate="let data of 'toolbarButtons'">
      <button class="btn btn-sm btn-success me-2" (click)="edit()">Add Manual Load</button>
      <button
        class="btn btn-sm btn-primary me-2"
        (click)="edit(dataGrid.instance.getSelectedRowsData()[0])"
        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
        >
        Open
      </button>
      <button class="btn btn-sm btn-danger me-4" (click)="delete()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Delete</button>
      <button
        class="btn btn-sm btn-primary me-2"
        (click)="assignCustomer(dataGrid.instance.getSelectedRowsData())"
        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
        >
        Assign Customer
      </button>
      <button
        class="btn btn-sm btn-primary me-2"
        (click)="assignProduct(dataGrid.instance.getSelectedRowsData())"
        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
        >
        Assign Product
      </button>
      <button
        class="btn btn-sm btn-primary me-3"
        (click)="editAdditives(dataGrid.instance.getSelectedRowsData()[0])"
        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
        >
        Edit Additives
      </button>
      <button class="btn btn-sm btn-success me-3" (click)="createInvoices()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Create Invoices</button>
      <button
        class="btn btn-sm btn-success me-3"
        (click)="createQuote(dataGrid.instance.getSelectedRowsData()[0])"
        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
        >
        Create Quote
      </button>
      <button
        class="btn btn-sm btn-warning"
        (click)="toggleOnHold(dataGrid.instance.getSelectedRowsData())"
        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
        >
        On Hold
      </button>
      <button class="btn btn-sm btn-secondary ms-4" (click)="getData()">Refresh</button>
    </div>
    <div *dxTemplate="let data of 'toolbarText'">
      @if (loads) {
        <span class="me-3">
          <strong>
            {{ dataGrid.instance.totalCount() + " items" }}
            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
          </strong>
        </span>
      }
    </div>
  </dx-data-grid>
</div>
</div>
